<template>
  <v-layout class="user-info" id="icon-user-info" v-if="user">
    <v-menu offset-y :nudge-bottom="10" origin="center center" transition="scroll-y-transition" :max-width="240">
      <template v-slot:activator="{ on }">
        <div v-on="on" class="user-info__photo">
          <v-card class="user-info__icon" :img="photo"></v-card>

          <v-icon class="arrow">keyboard_arrow_down</v-icon>

          <span v-if="innerWidth > 768">{{ user.name.split(' ')[0] }}</span>
        </div>
      </template>

      <v-list class="pa-0 rounded-0" dense>
        <v-list-item>
          <v-list-item-content class="text-center">
            <v-list-item-subtitle class="text--primary">{{ user.name }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <template v-for="(item, index) in menu">
          <v-list-item @click="handleLoadRoute(item)" :id="`menu-suspended-${item.id}`" dense ripple :key="item.id">
            <v-icon color="primary" class="mr-2" v-if="item.icon">{{ item.icon }}</v-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider :key="index"></v-divider>
        </template>

        <v-list-item @click="showVersion()" dense ripple>
          <v-icon color="primary" class="mr-2">fas fa-info-circle</v-icon>
          <v-list-item-content>
            <v-list-item-title>Versão do Sistema</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="editPassword()" dense ripple>
          <v-icon color="primary" class="mr-2">fas fa-key</v-icon>
          <v-list-item-content>
            <v-list-item-title>Alterar Senha</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="initTrace()" dense ripple>
          <v-icon :color="executeTrace ? 'red' : 'primary'" class="mr-2">{{ executeTrace ? 'fas fa-pause' : 'fas fa-play' }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>
              <span v-if="executeTrace" class="red--text">
                Trace
                <small>(executando)</small>
              </span>
              <span v-if="!executeTrace">Trace</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="logoff()" dense ripple>
          <v-icon color="primary" class="mr-2">fas fa-power-off</v-icon>
          <v-list-item-content>
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <I4proDialogPassword v-if="dialog" @handleAccount="handleAccount" />
    <I4proDialogVersion :dialog="dialogVersion" @handleVersion="handleVersion" />
  </v-layout>
</template>

<script>
import store from '@/store';
import { trace, statusTrace } from '@/services/administration';
import { downloadFile } from '@/helpers/utils';
import { handleLoadRoute } from '@/helpers/page';

export default {
  components: {
    I4proDialogPassword: () => import('@/components/dialogs/i4pro-dialog-password'),
    I4proDialogVersion: () => import('@/components/dialogs/i4pro-dialog-version')
  },

  props: {
    innerWidth: { type: Number, default: 0 }
  },

  data() {
    return {
      user: '',
      dialog: false,
      dialogVersion: false,
      executeTrace: false
    };
  },

  async beforeCreate() {
    await this.$store.dispatch('authentication/getProfile');
  },

  async created() {
    this.getProfile();

    let { data } = await statusTrace();
    this.executeTrace = data;
  },

  methods: {
    handleLoadRoute,

    editPassword() {
      this.dialog = true;
    },

    showVersion() {
      this.dialogVersion = true;
    },

    handleAccount() {
      this.dialog = false;
    },

    handleVersion() {
      this.dialogVersion = false;
    },

    getProfile() {
      this.user = this.$store.getters['authentication/getUser'] || JSON.parse(sessionStorage.getItem('i4pro-portal')).authentication.user;
    },

    logoff() {
      store.dispatch('authentication/logoff');
    },

    async initTrace() {
      const response = await trace();

      if (response.status === 204) {
        this.executeTrace = true;
      } else if (response.status === 200 && response.data) {
        this.executeTrace = false;

        downloadFile(response.data, 'application/octet-stream', 'zip', `trace-${new Date().getTime()}`);
      }
    }
  },

  computed: {
    photo() {
      if (this.user) {
        return this.user.photo ? this.user.photo : 'static/icon-user.jpg';
      }

      return 'static/icon-user.jpg';
    },

    menu: () => store.getters['menu/getMenuSuspended']
  },

  watch: {
    $route() {
      this.getProfile();
    }
  }
};
</script>

<style lang="scss" scoped>
.v-menu__content {
  overflow: visible;
  contain: initial;
  max-width: 90%;
  border-bottom: 3px solid var(--v-primary-base);

  &:after {
    bottom: 100%;
    left: 50%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(136, 183, 213, 0);
    border-width: 8px;
    transform: translateX(-50%);
  }
}

.user-info {
  .user-info__photo {
    display: flex;
    align-items: center;
    height: 100%;
    span {
      font-size: 14px;
    }
  }
}

.theme--dark {
  .v-menu__content {
    &:after {
      border-bottom-color: #424242;
    }
  }
}

.theme--light {
  .v-menu__content {
    &:after {
      border-bottom-color: #ffffff;
    }
  }
}
</style>
